import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { isAuthenticated } from '../../services/api';
import '../Unauthorized/unauthorized.css';

const apiUnavailableReasonKey = 'api_unavailable_reason';

function getApiUnavailableReason() {
    try {
        return sessionStorage.getItem(apiUnavailableReasonKey) || '';
    } catch {
        return '';
    }
}

function ApiUnavailable() {
    const backPath = isAuthenticated() ? '/' : '/login';
    const backLabel = isAuthenticated() ? 'Tentar novamente' : 'Ir para login';
    const technicalReason = getApiUnavailableReason();

    useEffect(() => {
        if (!technicalReason) {
            return;
        }

        console.error('[API indisponível] Detalhe técnico:', technicalReason);
    }, [technicalReason]);

    return (
        <div className='unauthorized-page'>
            <div className='unauthorized-card container-white'>
                <h1>Estamos com instabilidade de comunicação</h1><br />

                <p>
                    Não conseguimos comunicar com o servidor neste momento.
                    Isso pode acontecer por indisponibilidade temporária ou falha de rede.
                    Aguarde alguns instantes e tente novamente.
                </p>

                <Link to={backPath} className='unauthorized-link'>
                    {backLabel}
                </Link>
            </div>
        </div>
    );
}

export default ApiUnavailable;
